export default "__VITE_ASSET__882e8c5b__"